import React, { useState, useEffect, useMemo } from 'react';

import HandleVillageGraphData from './HandleVillageGraphData';
import ScaleComparasionLineGraph from './ScaleComparasionLineGraph';
import ScaleComparasionBarGraph from './ScaleComparasionBarGraph';

import {
  villageOysterTermList,
  villageOysterFacilityTermList,
  villageOysterFarmingTermList,
} from 'data/social-economic-data';
import YearSelect from './YearSelect';
import { BE_URL } from 'utils/config';

function ScaleComparasionContent({ active, setActive }) {
  const [rawData, setRawData] = useState({});
  const [data, setData] = useState({});
  const [seriesName, setSeriesName] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${BE_URL}/api/oyster-stats/`);
        if (!res.ok) throw new Error('Network response was not ok');
        const json = await res.json();
        const obj = {
          全國: json.countryOysterData || [],
          彰化縣: json.townOysterData || [],
          芳苑鄉: json.villageOysterData || [],
        };
        setRawData(obj);
        setSeriesName(Object.keys(obj));
      } catch (e) {
        console.error('載入 OysterFarmingStats 失敗:', e);
        setErr(e);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const isMappedReady = useMemo(() => {
    if (!seriesName.length) return false;
    return seriesName.every((name) => {
      const arr = data?.[name];
      return (
        Array.isArray(arr) &&
        arr.length > 0 &&
        Object.prototype.hasOwnProperty.call(arr[0] || {}, '年份')
      );
    });
  }, [data, seriesName]);

  if (loading) return <p>資料載入中...</p>;
  if (err) return <p>資料載入失敗，請稍後再試</p>;

  return (
    <>
      {seriesName.map((name) => (
        <HandleVillageGraphData
          key={name}
          setData={setData}
          type={name}
          rawData={rawData[name] || []}
          termList={villageOysterTermList}
          result="obj"
        />
      ))}

      {!isMappedReady && <p>目前沒有資料可顯示</p>}

      {isMappedReady && (
        <>
          <div className="l-social-economy-data__section">
            <ScaleComparasionLineGraph data={data} seriesName={seriesName} />
          </div>

          <div className="l-social-economy-data__section">
            <YearSelect
              active={active}
              setActive={setActive}
              data={data}
              seriesName={seriesName}
            />
            <div className="row">
              {[
                {
                  id: 'facility',
                  title: '設施數',
                  col: '設施',
                  unit: '組、棚',
                  termList: villageOysterFacilityTermList,
                },
                {
                  id: 'farming',
                  title: '養殖戶數',
                  col: '養殖',
                  unit: '戶',
                  termList: villageOysterFarmingTermList,
                },
              ].map((item) => (
                <ScaleComparasionBarGraph
                  key={item.id}
                  active={active}
                  data={data}
                  item={item}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ScaleComparasionContent;
